import { z } from "zod";
import type { FindingCategory } from "./enums";

// Icons of findings on the maps (issue #160): ten predefined pictures, each with a description
// in the UI, picked when a finding is reported on the phone or in the panel. An icon belongs to
// one category, which keeps the colour (colors.ts) and the meaning for reports. Both apps draw
// them with lucide (lucide-react, lucide-react-native) under the names below.

export const FINDING_ICONS = [
  "footprints",
  "clothing",
  "bag",
  "phone",
  "personal",
  "camp",
  "vehicle",
  "witness",
  "hazard",
  "other",
] as const;
export const FindingIcon = z.enum(FINDING_ICONS);
export type FindingIcon = z.infer<typeof FindingIcon>;

export const FINDING_ICON_CATEGORY: Record<FindingIcon, FindingCategory> = {
  footprints: "trace",
  clothing: "item",
  bag: "item",
  phone: "item",
  personal: "item",
  camp: "trace",
  vehicle: "item",
  witness: "witness",
  hazard: "hazard",
  other: "other",
};

/** lucide icon file names; the PNGs for the phone map are generated from them. */
export const FINDING_ICON_LUCIDE: Record<FindingIcon, string> = {
  footprints: "footprints",
  clothing: "shirt",
  bag: "backpack",
  phone: "smartphone",
  personal: "wallet",
  camp: "tent",
  vehicle: "car",
  witness: "eye",
  hazard: "triangle-alert",
  other: "circle-question-mark",
};

/** Findings reported before icons existed show the icon of their category. */
const CATEGORY_ICON: Record<FindingCategory, FindingIcon> = {
  trace: "footprints",
  item: "personal",
  witness: "witness",
  hazard: "hazard",
  other: "other",
};

export function findingIconOf(finding: {
  icon?: FindingIcon | null;
  category: FindingCategory;
}): FindingIcon {
  return finding.icon ?? CATEGORY_ICON[finding.category];
}
